import { createContext, useContext, useRef, type ReactNode } from "react";
import { Toast } from "primereact/toast";

interface ToastContextValue {
  showSuccess: (summary: string) => void;
}

const ToastContext = createContext<ToastContextValue | null>(null);

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const toast = useRef<Toast>(null);

  const showSuccess = (summary: string) => {
    toast.current?.show({
      severity: "success",
      summary,
      life: 3000,
    });
  };

  return (
    <ToastContext.Provider value={{ showSuccess }}>
      {children}
      <Toast ref={toast} position="top-right" />
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within ToastProvider");
  }
  return context;
};
